var AnimationService = {
  // Generalized animation queue
  // This parses a class selector of type `.queue-animationStyle-indexInQueue .queue`
  // .e.g. : queue-fadeIn-1 .queue .delay-1-second
  queueAnimationsRun: function() {
    const queue          = [...$('.queue')];
    const selectorRegExp = /\.?queue-([a-zA-Z]+)-(\d+)/;
    if(!queue.length)   return;
    queue.sort(function(a,b) {
       a = a.attributes.class.value.split(' ').filter(e => e.match(selectorRegExp));
       b = b.attributes.class.value.split(' ').filter(e => e.match(selectorRegExp));
       return selectorRegExp.exec(a)[2] - selectorRegExp.exec(b)[2];
    });
    const start = selectorRegExp.exec(
      queue[0].attributes.class.value.split(' ')
        .filter(e => e.match(selectorRegExp))
    )[1];
    $(queue[0]).addClass(`${start} animated`);
    queue.forEach((e,i) => {
      const $e = $(e);
      if(i < queue.length-1) {
        const selected = selectorRegExp.exec(
          queue[i+1].attributes.class.value.split(' ')
            .filter(e => e.match(selectorRegExp))
        );
        const animation = selected[1];
        const index     = selected[2];
        $e.one([
          'transitionend webkitTransitionEnd oTransitionEnd',
          'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend'].join(' '), function() {
          $(queue[i+1]).addClass(`${animation} animated`);
        });
      }
    });    
  }  
};

module.exports = AnimationService;